import { ROUTES } from '@ab-core/functions';
import { isChangeLogUnread } from '@ab-core/gatsby-theme-core/src/scopes/changeLog/components/changeLogRead';
import { getChangeLog } from '@ab-core/gatsby-theme-core/src/scopes/changeLog/components/getChangeLog';
import { Icon } from '@ab-core/icon';
import { navigationStore } from '@ab-core/store';
import Text from '@ab-core/text';
import { navigate } from 'gatsby';
import type { FC } from 'react';
import React from 'react';

export const ChangeLogNotifications: FC = () => {
    const allContentfulChangeLog = getChangeLog();

    const goToChangeLog = () => {
        navigate(ROUTES.CHANGELOG);

        navigationStore.setters.setUserDropdownNavigation(false);
        navigationStore.setters.setUserNavigation(false);
    };

    const readMessages = (): boolean => isChangeLogUnread(allContentfulChangeLog?.nodes[0]?.createdAt);

    return (
        <div className=" flex pointer gap-small2 " onClick={() => goToChangeLog()}>
            <div className="flex">
                <Icon name={readMessages() ? 'NotificationNews' : 'Notification'} />
            </div>

            <Text>Neuigkeiten</Text>
        </div>
    );
};
